import type { SixtyThirtyTenPalette } from "./palette-generator";

/**
 * Formats a 60:30:10 palette into a plain-text order payload for a dealer.
 * Pure function — easy to unit test and to reuse for the "copy" button
 * as well as the WhatsApp link.
 */
export function buildDealerMessage(palette: SixtyThirtyTenPalette): string {
  const lines = [
    "NEORISE Color Order",
    "",
    `Base (60%): ${palette.base.name} — ${palette.base.shadeCode} (${palette.base.hex})`,
    `Structure (30%): ${palette.structure.name} — ${palette.structure.shadeCode} (${palette.structure.hex})`,
    `Focus (10%): ${palette.focus.name} — ${palette.focus.shadeCode} (${palette.focus.hex})`,
  ];
  return lines.join("\n");
}

/**
 * Builds a wa.me deep link for the given message.
 *
 * The original spec's version of this (`https://wa.me/?text=...`) didn't
 * encode the payload — a message containing line breaks, `&`, or `#`
 * (all of which the message above has) would silently truncate or break
 * the link. `encodeURIComponent` is required here, not optional.
 *
 * @param phoneNumber Optional dealer phone number in international
 *   format without symbols (e.g. "919876543210"). If omitted, WhatsApp
 *   opens its own contact picker for the user to choose a recipient.
 */
export function buildWhatsAppLink(message: string, phoneNumber?: string): string {
  const encoded = encodeURIComponent(message);
  const base = phoneNumber
    ? `https://wa.me/${phoneNumber}`
    : "https://wa.me/";
  return `${base}?text=${encoded}`;
}
